<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" :model="formData" :rules="rules" ref="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="orderId" label="采购订单">
              <el-select @change="loadDeliveryList" v-model="formData.orderId" clearable filterable
                placeholder="请选择采购订单">
                <el-option v-for="(item, index) of orderList" :value="item.orderId"
                  :label="item.orderTitle + ' / ' + item.supplierName" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="deliveryId" label="提货单">
              <el-select v-model="formData.deliveryId" clearable @change="onDeliveryChange" filterable placeholder="请选择提货单">
                <el-option v-for="(item, index) of deliveryList" :value="item.deliveryId" :label="item.deliveryId"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商" prop="supplierId">
              <el-select v-model="formData.supplierId" clearable filterable placeholder="请选择供应商">
                <el-option v-for="(item) of supplierArr" :value="item.userId" :label="item.userName"
                  :key="item.userId"></el-option>
              </el-select> </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="invoiceAmount" label="发票金额(元)">
              <el-input-number v-model="formData.invoiceAmount" placeholder="请输入发票金额" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="invoiceTitle" label="发票抬头">
              <el-input v-model="formData.invoiceTitle" clearable placeholder="请输入发票抬头"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="invoiceType" label="发票类型">
              <el-input v-model="formData.invoiceType" clearable placeholder="请输入发票类型"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList" :maxSize="20"></file-upload>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

              <el-button type="primary" @click="submit">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'purchaseInvoiceAdd',
  data() {
    return {
      specList: [],
      formData: {
        deliveryId: '', // 提货ID
        orderId: '', // 订单ID
        supplierId: '',
        invoiceAmount: '',
        invoiceTitle: '',
        invoiceType: '',
        fileList: []
      },
      rules: {
        orderId: [{ required: true, message: '请选择采购订单', trigger: 'change' }],
        supplierId: [{ required: true, message: '请选择供应商', trigger: 'change' }],

        invoiceTitle: [{ required: true, message: '请输入发票抬头', trigger: 'blur' }],
        invoiceAmount: [{ required: true, message: '请输入发票金额', trigger: 'blur' }],
        invoiceType: [{ required: true, message: '请输入发票类型', trigger: 'blur' }]
      },
      orderList: [],
      deliveryList: [],
      supplierArr: []
    }
  },
  created() {
    this.loadUser()
    this.loadOrderList()
    if (this.invoiceId) {
      this.loadData()
    }
  },
  computed: {
    invoiceId() {
      return this.$route.query.invoiceId
    }
  },
  methods: {
    loadUser() {
      this.$axios.get(this.$apis.common.selectIparkUserByList, { userType: '4' }).then(res => {
        this.supplierArr = res || []
      })
      // this.$axios.get(this.$apis.system.selectSysUserByPage, { userType: '4' }).then(res => {
      //   this.supplierArr = res.list || []
      // })
    },
    loadData() {
      this.$axios.get(this.$apis.purchaseInvoice.selectYcInvoiceByInvoiceId, {
        params: { invoiceId: this.invoiceId }
      }).then(res => {
        res.fileList = res.fileList ? res.fileList : []
        this.formData = res || {}
      })
    },
    loadOrderList() {
      this.$axios.get(this.$apis.purchaseOrders.selectYcPurchaseOrderByList).then(res => {
        this.orderList = res.list || []
      })
    },
    loadDeliveryList(orderId) {
      const data = this.orderList.find(item => item.orderId === orderId)
      console.log('data', data)
      this.formData.invoiceAmount = data.purchasePrice || 0
      this.$axios.get(this.$apis.purchaseDelivery.selectYcDeliveryByList, {
        params: {
          orderId
        }
      }).then(res => {
        this.formData.deliveryId = ''
        this.deliveryList = res.list || []
      })
    },
    onDeliveryChange(deliveryId) {
      if (deliveryId) {
        const data = this.deliveryList.find(item => item.deliveryId === deliveryId)
        this.formData.invoiceAmount = data.paidPrice || 0
      }
    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.purchaseInvoice.insertYcInvoice
        if (this.invoiceId) {
          url = this.$apis.purchaseInvoice.updateYcInvoice
        }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-date-editor {
    width: 100%;
    max-width: 400px;

  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
